import { TaskValue } from 'lib/actions/task'
import { Provision } from 'pbts/c1/api/policy/v1/policy'
import { Approval } from 'pbts/c1/api/policy/v1/policy_steps_approval'
import { TaskAuditView } from 'pbts/c1/api/task/v1/audit'
import { Timestamp } from 'pbts/google/protobuf/timestamp'

export const isStepAssigned = (task: TaskValue): boolean => {
    if (!task.policy?.current?.instance) {
        return false
    }

    let o: Approval | Provision | undefined
    switch (task.policy.current.instance.oneofKind) {
        case 'approval':
            o = task.policy.current.instance.approval.approval
            return o ? o.assigned : false
        case 'provision':
            o = task.policy.current.instance.provision.provision
            return o ? o.assigned : false
        case 'wait':
            return true
        default:
            return false
    }
}

const getTaskAuditCreatedAt = (view: TaskAuditView): Date | null => {
    const createdAt = view.created
    if (!createdAt) {
        return null
    }

    return Timestamp.toDate(createdAt)
}

export const dateSort = (a: TaskAuditView, b: TaskAuditView): -1 | 1 => {
    const datea = getTaskAuditCreatedAt(a)
    const dateb = getTaskAuditCreatedAt(b)

    if (datea && dateb) {
        if (datea > dateb) {
            return -1
        }
        return 1
    }

    if (datea && !dateb) {
        return 1
    }

    if (!datea && dateb) {
        return -1
    }

    return 1
}
